// URL base de la API.
// En producción VITE_API_URL va vacía: la web llama a /api/... en su propio dominio
// y Vercel reenvía esas peticiones al proyecto del backend (ver vercel.json).
// En local, .env.local la apunta a http://localhost:3001.
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';
